export const Classe = {
    path: '/classes',
    name: 'classes',
    component: () => import('@/views/Grille/Classe/ClassePage.vue'),
    children: [
        {
            path: '/classes/add',
            name: 'classes.add',
            component: () => import('@/views/Grille/Classe/Form/ClasseForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/classes/edit/:id',
            name: 'classes.edit',
            component: () => import('@/views/Grille/Classe/Form/ClasseForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/classes/delete/:id',
            name: 'classes.delete',
            component: () => import('@/views/Grille/Classe/Form/ClasseForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/classes/view/:id',
            name: 'classes.view',
            component: () => import('@/views/Grille/Classe/Form/ClasseForm.vue'),
            props: {viewAction: true}
        },
    ]
}